(() => {
  const replaceParagraphWithHeading = (paragraph, tagName, className) => {
    const heading = document.createElement(tagName);

    Array.from(paragraph.attributes).forEach((attribute) => {
      heading.setAttribute(attribute.name, attribute.value);
    });

    heading.innerHTML = paragraph.innerHTML;
    heading.classList.add(className);
    paragraph.replaceWith(heading);

    return heading;
  };

  const enhanceLegalContent = (root) => {
    if (!root || root.dataset.legalEnhanced === "true") return;

    const paragraphs = Array.from(root.querySelectorAll("p"));
    const uppercaseLetters = /[A-ZČĆŽŠĐ]/g;
    const lowercaseLetters = /[a-zčćžšđ]/g;
    const headingCandidates = [];

    paragraphs.forEach((paragraph) => {
      const text = paragraph.textContent
        .replace(/\u00a0/g, " ")
        .replace(/\s+/g, " ")
        .trim();

      if (!text) {
        paragraph.classList.add("legal-page__empty");
        paragraph.setAttribute("aria-hidden", "true");
        return;
      }

      if (paragraph.closest("li")) {
        return;
      }

      const isNumberedHeading =
        /^(?:\d{1,2}|[IVXLCDM]+)[.)]\s+\S/i.test(text) && text.length <= 140;

      const uppercaseCount = (text.match(uppercaseLetters) || []).length;
      const lowercaseCount = (text.match(lowercaseLetters) || []).length;
      const isKeyValueLine = /:\s*\S/.test(text);
      const isUppercaseHeading =
        text.length <= 120 &&
        uppercaseCount >= 4 &&
        lowercaseCount === 0 &&
        !isKeyValueLine &&
        !/[.!?;]$/.test(text);

      const words = text.split(" ").filter(Boolean);
      const titleCaseWords = words.filter((word) =>
        /^[A-ZČĆŽŠĐ][A-Za-zČĆŽŠĐčćžšđ'-]*$/.test(word)
      ).length;
      const looksLikeBodySentence =
        /\b(?:je|su|se|za|na|u|od|do|i|ili|te|koji|koja|koje|putem|dostupan|dostupna|dostupni)\b/i.test(text);

      const isShortTitle =
        text.length <= 64 &&
        words.length >= 2 &&
        words.length <= 8 &&
        !/\d/.test(text) &&
        !isKeyValueLine &&
        !/[.!?;]$/.test(text) &&
        (
          titleCaseWords / words.length >= 0.6 ||
          (!looksLikeBodySentence && words.length <= 5)
        );

      const isLabel =
        text.endsWith(":") &&
        text.length <= 72 &&
        words.length >= 2;
      const isDeliveryOption =
        text.length <= 80 && text.includes(" / ") && !/\d/.test(text);
      const isFaqQuestion =
        text.length <= 120 && text.endsWith("?");
      const isMajorStandaloneHeading =
        /^(?:Cijene dostave|Troškovi dostave|Delivery (?:prices|costs)|Često postavljena pitanja(?:\s*\(FAQ\))?|Frequently asked questions(?:\s*\(FAQ\))?)$/i.test(text);

      if (isNumberedHeading || isUppercaseHeading || isMajorStandaloneHeading) {
        headingCandidates.push({ paragraph, level: 2 });
      } else if (isLabel || isShortTitle || isDeliveryOption || isFaqQuestion) {
        headingCandidates.push({ paragraph, level: 3 });
      }
    });

    if (
      !headingCandidates.some((candidate) => candidate.level === 2) &&
      headingCandidates.length > 0
    ) {
      headingCandidates[0].level = 2;
    }

    headingCandidates.forEach(({ paragraph, level }) => {
      replaceParagraphWithHeading(
        paragraph,
        level === 2 ? "h2" : "h3",
        level === 2
          ? "legal-page__section-heading"
          : "legal-page__subheading"
      );
    });

    root.querySelectorAll("li").forEach((item) => {
      const leadParagraph = Array.from(item.children).find((child) => {
        return (
          child.tagName === "P" &&
          child.textContent.replace(/\u00a0/g, " ").trim()
        );
      });

      if (leadParagraph) {
        leadParagraph.classList.add("legal-page__list-lead");
      }
    });

    root.dataset.legalEnhanced = "true";
  };

  const run = () => {
    document
      .querySelectorAll("[data-legal-content]")
      .forEach(enhanceLegalContent);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  document.addEventListener("shopify:section:load", run);
})();
